import { NpsSubmission } from '../types/nps.types'

// Placeholder submission service. Replace the body with the real API call when
// an endpoint is available - the signature and payload must remain stable so
// question components do not need to change.
export const submitNpsResponse = (payload: NpsSubmission): Promise<void> => {
    console.log('NPS Submission:', payload)
    return Promise.resolve()
}
